import { ChainId } from '@pancakeswap-libs/sdk'

const priceContracts: {chewyAddress: string, wwdogeAddress: string, usdtAddress: string, lpAddress: string, priceProxy: string} = {
  chewyAddress: '0x2761723006d3Eb0d90B19B75654DbE543dcd974f',
  wwdogeAddress: '0xb7ddc6414bf4f5515b52d8bdd69973ae205ff101',
  usdtAddress: '0xaB082b8ad96c7f47ED70ED971Ce2116469954cFB',
  lpAddress: '0x0E9674cff160A1aBCD57141BC8fD2E2598D99689',
  priceProxy: '0x670404e04Bf2f6F7F8bdb0Ed8714a01c5a1bf4C6'
}

export default priceContracts